import { render, staticRenderFns } from "./OnboardingAcctDatatable.vue?vue&type=template&id=1ba491b4&scoped=true&"
import script from "./OnboardingAcctDatatable.vue?vue&type=script&lang=js&"
export * from "./OnboardingAcctDatatable.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAcctDatatable.vue?vue&type=style&index=0&id=1ba491b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba491b4",
  null
  
)

export default component.exports